import { Component, Input, Output, EventEmitter, OnChanges, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { Product } from '../../../models/Product';
import { ProductService } from '../../../service/product.service';

@Component({
  selector: 'app-modal-edit-product',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './modal-edit-product.html',
  styleUrls: ['./modal-edit-product.scss']
})
export class ModalEditProduct implements OnChanges {

  @Input() product: Product | null = null;

  @Output() deleted = new EventEmitter<number>();
  @Output() updated = new EventEmitter<Product>();

  private fb = inject(FormBuilder);
  private productService = inject(ProductService);

  form = this.fb.nonNullable.group({
    codigo: [0],
    fkSeccion: [0],
    fkDivision: [0],
    fkClase: [0],
    codigoIne: ['', Validators.required],
    nombre: ['', Validators.required],
    codigoCiiu: [''],
    codigoNaeg: [''],
    codigoNpg: [''],
    codigoCcp: [''],
    referencia: [''],
    estado: ['A']
  });

  ngOnChanges() {
    if (!this.product) return;

    this.form.patchValue({
      codigo: this.product.codigo,
      fkSeccion: this.product.fkSeccion,
      fkDivision: this.product.fkDivision,
      fkClase: this.product.fkClase,
      codigoIne: this.product.codigoIne,
      nombre: this.product.nombre,
      codigoCiiu: this.product.codigoCiiu,
      codigoNaeg: this.product.codigoNaeg,
      codigoNpg: this.product.codigoNpg,
      codigoCcp: this.product.codigoCcp,
      referencia: this.product.referencia,
      estado: this.product.estado
    });
  }

  saveChanges() {
    if (this.form.invalid || !this.product) return;

    const updatedProduct: Product = {
      ...this.product,
      ...this.form.getRawValue(),
      segFuncion: 'EDIT',
      segUsuario: 1,
      segTransaccion: 6002,
      segDatosAnteriores: JSON.stringify(this.product)
    };

    this.productService.edit(updatedProduct).subscribe({
      next: () => {
        this.showToast('toastSuccessProduct');
        this.closeModal();
        this.updated.emit(updatedProduct);
      },
      error: () => {
        this.showToast('toastErrorProduct');
      }
    });
  }

  openDeleteModal() {
    const modal = new (window as any).bootstrap.Modal(
      document.getElementById('modalDeleteProduct')
    );
    modal.show();
  }

  confirmDelete() {
    if (!this.product?.codigo) return;

    this.productService.delete(this.product.codigo).subscribe({
      next: () => {
        this.showToast('toastDeleteProduct');

        const deleteModal = (window as any).bootstrap.Modal.getInstance(
          document.getElementById('modalDeleteProduct')
        );
        deleteModal?.hide();

        this.closeModal();
        this.deleted.emit(this.product?.codigo??.0);
      },
      error: () => {
        this.showToast('toastErrorProduct');
      }
    });
  }

  closeModal() {
    const modal = (window as any).bootstrap.Modal.getInstance(
      document.getElementById('modalEditProduct')
    );
    modal?.hide();
  }

  showToast(id: string) {
    const toastEl = document.getElementById(id);
    if (toastEl) new (window as any).bootstrap.Toast(toastEl).show();
  }
}
